<template>
  <v-container>
        <h1>
          {{ this.isBuy ? 'Buy Token' : 'Sell Token' }}
        </h1>
    
      <v-container>
        <h3>Please, enter the amount of tokens you want to {{ this.isBuy ? 'buy' : 'sell' }}</h3>
        <v-layout align-center row wrap>
          <v-flex xs12 sm6> 
            <v-text-field 
              v-model="amount"
              color="warning" 
              prepend-icon="fas fa-coins"
            />
          </v-flex>
          
          <v-flex xs1>
            <v-icon>fas fa-arrow-right</v-icon>
          </v-flex>

          <v-flex>
            <h2>
              <v-icon>fab fa-ethereum</v-icon>
              {{ ethAmount.toFixed(3) }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout>
          <h3>Total fee 0.2%</h3>
          <v-spacer />
          <h3>{{ feeAmount.toFixed(3) }} ETH</h3>
        </v-layout>

        <v-layout>
          <h3>Total</h3>
          <v-spacer />
          <h3>{{ totalAmount.toFixed(3) }} ETH</h3>
        </v-layout>								
      </v-container>
        <v-flex>
          <v-btn 
            :color="this.isBuy ? 'success' : 'error'" 
            block  
            :disabled="!this.isBuy"  
            @click="exchangeAction (amount)"
          >
             {{ this.isBuy ? 'Buy' : 'Sell' }}
          </v-btn>
        </v-flex>

  </v-container>
</template>

<script>
export default {
  props: {
    isBuy: {
      type: Boolean,
      default: true 
    },
    feeValue: {
      type: Number,
      default: 0 
    },
    re20Value: {
      type: Number,
      default: 0 
    },
    exchangeAction: {
      type: Function,
      required: true
    } 
  },
  data () {
		return {
			amount: null,
		}
  },
  computed: {
    ethAmount () {
			return this.amount * this.re20Value
		},
		
		feeAmount () {
			return (this.ethAmount * this.feeValue) / 100 
		},

		totalAmount () {
			return this.ethAmount + this.feeAmount
		},
  }
}
</script>